import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { addVahanData } from "../../Redux/actions/NumBikeation";
import {
  addcarnum,
  addcardetails,
  quick_quotes,
  QuickQuote_Post,
  Err_quotes,
} from "../../Redux/actions/NumCaration";
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Card,
  DatePicker,
  message,
  Select,
} from "antd/lib";
import moment from "moment";
import axiosInCar from "../../Redux/axios/AxiosInCar";
import _ from "lodash";
import "react-lazy-load-image-component/src/effects/blur.css";

export default function CarEdit({ setisModalBike }) {
  const CarNum = useSelector((state) => state?.cardetail?.carnum);
  const vechicleData = useSelector((state) => state?.common?.vahanData);
  const postQuotes = useSelector((state) => state?.cardetail?.quickQuotePost);
  const BikeMakeData = useSelector((state) => state?.cardetail?.carMakeData);
  const [form] = Form.useForm();
  const [formLayout] = useState("vertical");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [carNumDetail, setCarNumdeail] = useState(CarNum);
  const [options, setOptions] = useState([]);
  const [MakeData, setMakeData] = useState([]);
  const [ModalData, setModalData] = useState([]);
  const [VarientData, setVarientData] = useState([]);
  const [Makeoptions, setMakeoptions] = useState([]);
  const [VarientOption, setVarientOptions] = useState([]);
  const [bikemake, setBikeMake] = useState(BikeMakeData?.make);
  const [bikemodel, setModelSearch] = useState(BikeMakeData?.model);
  // const [bikeVarient, setSelectVarient] = useState('');
  // const [saveloading, setIsaveloading] = useState(false);

  useEffect(() => {
    //console.log(carNumDetail)
    form.setFieldsValue({
      BikeNumber: carNumDetail?.car_number,
      registrationYear: vechicleData?.registration_date
        ? moment(vechicleData?.registration_date)
        : null,
    });
  }, [vechicleData, BikeMakeData]);

  useEffect(() => {
    axiosInCar
      .get(`vehicle_masters?no_of_wheels=4`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.makes;
        //console.log(resp);
        const makeData = resp.map((item) => item);
        // console.log("resp", makeData);
        setMakeoptions(makeData);
        setMakeData(makeData);
      })
      .catch((err) => {
        //console.log(err);
      });
  }, []);

  const onSelectMake = (data) => {
    //console.log("onSelect", data);
    setBikeMake(data);
    // setIsaveloading(false)
    form.setFieldsValue({
      bikeModel: "",
      bikeVarient: "",
    });
  };
  //console.log(bikemake)

  useEffect(() => {
    axiosInCar
      .get(`vehicle_masters?no_of_wheels=4&make=${bikemake}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.models;
        //console.log(resp);
        const modelData = resp.map((item) => item);
        // console.log("resp", modelData);
        setOptions(modelData);
        setModalData(modelData);
      })
      .catch((err) => {
        console.log(err.response);
      });
  }, [bikemake]);

  const ModelChange = (e) => {
    setModelSearch(e);
    // setIsaveloading(false)
  };
  useEffect(() => {
    axiosInCar
      .get(`vehicle_masters?no_of_wheels=4&make=${bikemake}&model=${bikemodel}`)
      .then((res) => {
        //console.log(res);
        const resp = res?.data?.variants;
        //console.log(resp);
        const varientData = resp.map((item) => item);
        // console.log("resp", varientData);
        setVarientOptions(resp);
        setVarientData(resp);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [bikemodel]);

  const VarientChange = (variant, option) => {
    // console.log(variant,option)
    // setSelectVarient(variant)
    axiosInCar
      .get(
        `vehicle_masters?no_of_wheels=4&make=${bikemake}&model=${bikemodel}&variant=${variant}`
      )
      .then((res) => {
        const resp = res?.data;
        //console.log(resp);
        dispatch(
          addcardetails({
            ...BikeMakeData,
            VehicleCoreCode: resp?.vehicle_core_code,
            customized_variant: option?.label,
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
    // setIsaveloading(false)
  };

  const buttonItemLayout = {
    wrapperCol: {
      span: 24,
    },
  };

  const onDateChange = (date, dateString) => {
    //console.log(date);
    // console.log(dateString)
    //setRegDate(dateString)
  };
  const debouncedHandleInputChange = _.debounce((e) => {
    // setIsaveloading(true);
    const inputValue = e.target.value.toUpperCase();
    setCarNumdeail({ ...carNumDetail, car_number: inputValue });
    const updatedVal = {
      ...carNumDetail,
      car_number: inputValue,
    };
    axiosInCar
      .post("getVehicleDetails", { vehicleNumber: inputValue })
      .then((res) => {
        //console.log(res);
        let bikeresult = res?.data?.data;
        //console.log(bikeresult)
        dispatch(addVahanData(bikeresult));
        dispatch(addcarnum(updatedVal));
        // setIsaveloading(false);
      })
      .catch((error) => {
        console.error(error);
        // setIsaveloading(false);
      });
  }, 500);

  const handleInputChange = (e) => {
    debouncedHandleInputChange(e);
    form.setFieldsValue({ BikeNumber: e.target.value.toUpperCase() });
  };

  const onFinish = (data) => {
    console.log("data", data);
    //const inputString = data?.bikeVarient;
    //const varResult = inputString.split(" / ")[0];

    dispatch(
      addcardetails({
        ...BikeMakeData,
        make: data.bikeMake,
        model: data.bikeModel,
        year: moment(data.registrationYear).format("YYYY-MM-DD"),
        varbike: data.bikeVarient,
      })
    );
    dispatch(addcarnum(carNumDetail));
    const updatedQuotePost = {
      ...postQuotes,
      licensePlateNumber: data?.BikeNumber,
      make: data?.bikeMake,
      model: data?.bikeModel,
      variant: data?.bikeVarient,
      registrationDate: moment(data.registrationYear).format("YYYY-MM-DD"),
      vehicle_core_code: BikeMakeData?.VehicleCoreCode,
    };
    console.log(updatedQuotePost);
    setLoading(true);
    axiosInCar
      .post(
        `v2/car_insurances/${CarNum?.car_insurance_id}/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          //console.log("data-----------------",data)
          const errData = data?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(Err_quotes(errData));
          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
          }));
          dispatch(quick_quotes(updatedData));
          dispatch(QuickQuote_Post(updatedQuotePost));
          setisModalBike(false);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err.response.data);
        setLoading(false);
        setisModalBike(false);
        message.error(err.response.data.message);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Form
        layout={formLayout}
        form={form}
        style={{ width: "100%" }}
        className="ant-quote-form col-xl-6 col-lg-6 col-md-6"
        requiredMark={false}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              label="Car Number"
              name="BikeNumber"
              rules={[
                {
                  pattern: /^[A-Z]{2}[0-9]{1,2}[A-Z]{1,2}[0-9]{3,4}$/i,
                  message: "Invalid Vehicle No",
                },
                { required: true, message: "Enter Vehicle No" },
              ]}
            >
              <Input
                onChange={handleInputChange}
                placeholder="Enter Car Number (eg. DL1SAB1234)"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="bikeMake"
              label="Select Make"
              rules={[
                {
                  required: true,
                  message: "Please Select Make",
                },
              ]}
              initialValue={BikeMakeData?.make}
            >
              <Select
                placeholder="Select Make"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={MakeData?.map((p, index) => ({
                  key: index,
                  value: p,
                  label: p,
                }))}
                // onChange={(e)=>onSelectMake(e)}
                onSelect={(e) => onSelectMake(e)}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="bikeModel"
              label="Select Model"
              rules={[
                {
                  required: true,
                  message: "Please Select Model",
                },
              ]}
              initialValue={BikeMakeData?.model}
            >
              <Select
                placeholder="Select Model"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={ModalData?.map((p, index) => ({
                  key: index,
                  value: p,
                  label: p,
                }))}
                // onChange={(e)=>ModelChange(e)}
                onSelect={(e) => ModelChange(e)}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="bikeVarient"
              label="Select Variant"
              rules={[
                {
                  required: true,
                  message: "Please Select Variant",
                },
              ]}
              initialValue={BikeMakeData?.varbike}
            >
              <Select
                placeholder="Select Variant"
                showSearch
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                options={VarientData?.map((p, index) => ({
                  key: index,
                  value: p.variant,
                  label: p.customized_variant,
                }))}
                onChange={(variant, option) => VarientChange(variant, option)}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Registration Year"
              name="registrationYear"
              rules={[
                {
                  required: true,
                  message: "please input Registration Year",
                },
              ]}
              initialValue={
                postQuotes?.registrationDate
                  ? moment(postQuotes?.registrationDate)
                  : null
              }
            >
              <DatePicker
                style={{ width: "100%", padding: "8px" }}
                format="YYYY-MM-DD"
                onChange={onDateChange}
                placeholder="Select Registration Date"
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item {...buttonItemLayout}>
              <Button
                style={{ width: "100%" }}
                loading={loading}
                type="primary"
                htmlType="submit"
              >
                GET QUOTES
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}
